import moment from 'moment-timezone';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAppHeader } from 'components/shared/AppHeader/AppHeader';
import { ColorTheme } from 'enum/ColorTheme';
import { IMessage } from 'interfaces/IMessage';
import { IApiError } from 'interfaces/IApiError';
import { IConfirmModal } from 'utils/callConfirmModal';
import { languages } from 'constants/languages';

export interface IAccountState {
  appHeader: IAppHeader;
  colorTheme: ColorTheme,
  isAppLoader: boolean;
  confirmModal: IConfirmModal | null;
  message: IMessage | null;
  apiError: IApiError | null;
  isNavDisabled: boolean;
  timeZone: string;
  language: string;
}

export const initialState: IAccountState = {
  appHeader: {
    title: '',
    hideTitle: true,
  },
  colorTheme: ColorTheme.BLUE,
  isAppLoader: true,
  confirmModal: null,
  message: null,
  apiError: null,
  isNavDisabled: false,
  timeZone: moment.tz.guess(),
  language: languages.EN,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppHeader(state, action: PayloadAction<IAppHeader>) {
      state.appHeader = action.payload;
    },
    setColorTheme(state, action: PayloadAction<ColorTheme>) {
      state.colorTheme = action.payload;
    },
    setIsAppLoader(state, action: PayloadAction<boolean>) {
      state.isAppLoader = action.payload;
    },
    setConfirmModal(state, action: PayloadAction<IConfirmModal | null>) {
      state.confirmModal = action.payload;
    },
    setMessage(state, action: PayloadAction<IMessage | null>) {
      state.message = action.payload;
    },
    setApiError(state, action: PayloadAction<IApiError | null>) {
      state.apiError = action.payload;
    },
    setIsNavDisabled(state, action: PayloadAction<boolean>) {
      state.isNavDisabled = action.payload;
    },
    setTimeZone(state, action: PayloadAction<string>) {
      state.timeZone = action.payload;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
    resetAppHeaderState(state) {
      state.appHeader = initialState.appHeader;
    },
  },
});

export const {
  setAppHeader,
  setColorTheme,
  resetAppHeaderState,
  setIsAppLoader,
  setConfirmModal,
  setMessage,
  setApiError,
  setIsNavDisabled,
  setTimeZone,
  setLanguage,
} = appSlice.actions;

export default appSlice.reducer;
